import React, { useEffect, useState } from "react";
import "./VideoConfig.scss";

import { fetchContentPublications } from "../services/apiContent";
import {
  fetchVideoConfig,
  saveVideoConfig,
  deleteVideoConfig
} from "../services/apiVideoConfig";
import { BASE_URL } from "../services/constant";


const DAYS = [
  { label: "Lundi", value: 1 },
  { label: "Mardi", value: 2 },
  { label: "Mercredi", value: 3 },
  { label: "Jeudi", value: 4 },
  { label: "Vendredi", value: 5 },
  { label: "Samedi", value: 6 },
  { label: "Dimanche", value: 7 }
];

export default function VideoConfig() {
  const [search, setSearch] = useState("");
  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [configId, setConfigId] = useState(null);
  const [days, setDays] = useState([]);
  const [fullDay, setFullDay] = useState(true);
  const [startTime, setStartTime] = useState("13:00");
  const [endTime, setEndTime] = useState("14:30");

  const [message, setMessage] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [page, setPage] = useState(1);
  const [currentTab, setCurrentTab] = useState(1); // 1 = non publié, 2 = publié
  const [savingIds, setSavingIds] = useState({});
  const [isDefault, setIsDefault] = useState(false);


  const rowsPerPage = 10;

  /* =======================
     Charger vidéos publiées
     ======================= */
  useEffect(() => {
    async function loadVideos() {
      const data = await fetchContentPublications(2);
      setVideos(data || []);
    }
    loadVideos();
  }, []);

  
  useEffect(() => {
    setFiltered(
      videos.filter((v) =>
        v.title.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [search, videos]);

  
  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const displayed = filtered.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );
  /* =======================
     Charger config vidéo
     ======================= */
  useEffect(() => {
    if (!selectedVideo) return;

    async function loadConfig() {
      const cfg = await fetchVideoConfig(selectedVideo.id);

      if (cfg) {
        setConfigId(cfg.id);
        setDays(cfg.days_of_week || []);
        setFullDay(cfg.full_day);
        setStartTime(cfg.start_time || "00:00");
        setEndTime(cfg.end_time || "23:59");
        setIsDefault(!!cfg.is_default); // 👈 AJOUT
      } else {
        setConfigId(null);
        setDays([]);
        setFullDay(true);
      }
    }

    loadConfig();
  }, [selectedVideo]);

  /* =======================
     Gestion jours
     ======================= */
  const toggleDay = (day) => {
    setDays((prev) =>
      prev.includes(day)
        ? prev.filter((d) => d !== day)
        : [...prev, day]
    );
  };

  /* =======================
     Sauvegarde
     ======================= */
  const handleSave = async () => {
    if (days.length === 0) {
      alert("Sélectionnez au moins un jour");
      return;
    }

    try {
      await saveVideoConfig({
        video_id: selectedVideo.id,
        days_of_week: days,
        full_day: fullDay,
        start_time: fullDay ? null : startTime,
        end_time: fullDay ? null : endTime,
        is_default: isDefault // 👈 AJOUT
      });

      setMessage("✅ Configuration enregistrée");

      setTimeout(() => {
        setShowModal(false);
        setMessage("");
      }, 800);
    } catch (err) {
      console.error(err);
      setMessage("❌ Erreur lors de l’enregistrement");
    }
  };

  /* =======================
     Suppression
     ======================= */
  const handleDelete = async () => {
    if (!configId) return;

    if (!window.confirm("Supprimer la configuration ?")) return;

    await deleteVideoConfig(configId);

    setConfigId(null);
    setDays([]);
    setFullDay(true);
    setMessage("🗑️ Configuration supprimée");

    setTimeout(() => setShowModal(false), 500);
  };


  
  // Limiter la description
function limitText(text, max = 250) {
  if (!text) return "";
  return text.length > max ? text.substring(0, max) + "..." : text;
}

// Convertir durée (secondes → HH:MM:SS)
function formatDuration(seconds) {
  if (!seconds || isNaN(seconds)) return "00:00";

  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  // si 0 heure : n'afficher que mm:ss
  if (h === 0) {
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }

  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(
    s
  ).padStart(2, "0")}`;
}
function formatNumber(num) {
  if (num < 10000) {
    return num.toString();
  }

  if (num < 1000000) {
    const value = (num / 1000).toFixed(1);
    return value.endsWith('.0') ? `${parseInt(value)}k` : `${value}k`;
  }

  const value = (num / 1000000).toFixed(1);
  return value.endsWith('.0') ? `${parseInt(value)}M` : `${value}M`;
}



// Formater date MySQL → "26 Aug 2022"
function formatDate(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

  /* =======================
     Formulaire config
     ======================= */
  const renderForm = () => (
    <>
      <h3 className="vc-subtitle">Lecture par défaut</h3>

      <div className="vc-checkbox">
        <input
          type="checkbox"
          checked={isDefault}
          onChange={(e) => setIsDefault(e.target.checked)}
        />
        <span>
          Lancer cette vidéo par défaut au démarrage du lecteur
        </span>
      </div>

      <hr className="vc-divider" />

      <h3 className="vc-subtitle">Jours de diffusion</h3>

      <div className="vc-checkbox">
        <input
          type="checkbox"
          checked={days.length === 7}
          onChange={(e) =>
            setDays(e.target.checked ? [1,2,3,4,5,6,7] : [])
          }
        />
        <span>Tous les jours</span>
      </div>

      <div className="vc-days">
        {DAYS.map((d) => (
          <button
            key={d.value}
            className={`vc-day ${days.includes(d.value) ? "active" : ""}`}
            onClick={() => toggleDay(d.value)}
          >
            {d.label}
          </button>
        ))}
      </div>

      <hr className="vc-divider" />

      <h3 className="vc-subtitle">Plage horaire</h3>

      <div className="vc-checkbox">
        <input
          type="checkbox"
          checked={fullDay}
          onChange={(e) => setFullDay(e.target.checked)}
        />
        <span>Disponible 24h / 24</span>
      </div>

      {!fullDay && (
        <div className="vc-time">
          <label>De</label>
          <input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} />
          <label>À</label>
          <input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} />
        </div>
      )}

      <div className="vc-actions">
        <button className="vc-btn" onClick={handleSave}>💾 Enregistrer</button>
        {configId && (
          <button className="vc-btn danger" onClick={handleDelete}>🗑️ Supprimer</button>
        )}
      </div>

      {message && <p className="vc-message">{message}</p>}
    </>
  );

  return (
    <div className="page-content">
      <div className="video-list-container">
        <h1 className="vc-title">Configuration des vidéos</h1>
        
      {/* Tabs */}
      <div className="tabs">
        <button
          className={`tab ${currentTab === 1 ? "active" : ""}`}
          onClick={() => setCurrentTab(1)}
        >
          Videos publiés
        </button>

        <button
          className={`tab ${currentTab === 2 ? "active" : ""}`}
          onClick={() => setCurrentTab(2)}
        >
          Videos configurés
        </button>
      </div>
       {/* Search / Filter */}
       <div className="filter-bar">
        <input
          type="text"
          placeholder="Filter videos..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

        {/* TABLE VIDEOS */}
        <div className="vc-card">
          <table className="vc-table video-table">
            <thead>
              <tr>
                <th></th>
                <th>Video</th>
                <th>Catégorie</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
            {displayed.map((v) => (
                <tr key={v.id}>
                    <td>
                        <input type="checkbox" />
                    </td>
                    <td className="video-cell">
                        <div className="thumb">
                        <img src={`${BASE_URL}api/${v.image}`} alt={v.id} />
                        <span className="duration">{formatDuration(v.duration)}</span>
                        </div>
                        <div className="video-info">
                            <strong>{v.title}</strong>
                            <p>{limitText(v.description, 50)}</p>
                            <p>Acteur</p>
                        </div>
                    </td>
                    <td>Publicité</td>
                    <td>{formatDate(v.created_at)}</td>
                  <td>
                    <button
                      className="vc-btn"
                      onClick={() => {
                        setSelectedVideo(v);
                        setShowModal(true);
                      }}
                    >
                      ⚙️ Configurer
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      {/* Pagination */}
      <div className="pagination">
        <span>
          Rows per page: <b>{rowsPerPage}</b>
        </span>
        <span>
          {page} – {Math.ceil(filtered.length / rowsPerPage)} of{" "}
          {filtered.length}
        </span>
        <button
          disabled={page === 1}
          onClick={() => handleChangePage(page - 1)}
        >
          ‹
        </button>
        <button
          disabled={page * rowsPerPage >= filtered.length}
          onClick={() => handleChangePage(page + 1)}
        >
          ›
        </button>
      </div>

        {/* MODAL */}
        {showModal && selectedVideo && (
          <div className="vc-modal-overlay">
            <div className="vc-modal">
              <button
                className="vc-modal-close"
                onClick={() => setShowModal(false)}
              >
                ✕
              </button>

              <h2 className="vc-subtitle">
                Configuration – {selectedVideo.title}
              </h2>

              {renderForm()}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
